export enum PeoplePickerType {
    Normal = 1,Compact,MembersList,Preselected
  }
  export enum PeoplePickerSelectionMode {
    Single = 1,Multiple
  }
  export enum PeoplePickerContentType {
      User = 'user',Group = 'group',ExternalUser = 'externalUser', FTEUser ='fteUser', AllUser = 'allUser', NonSCUser = 'nonscuser'
  }